import { AnimatePresence, motion } from 'framer-motion'
import { RefreshCw, X } from 'lucide-react'
// Virtual module provided by vite-plugin-pwa. Safe in dev (SW disabled there).
import { useRegisterSW } from 'virtual:pwa-register/react'

// Small glass toast that appears when a new service worker has been installed.
// `registerType: 'autoUpdate'` activates it, but a running client keeps old
// chunks until reload — this gives the user a one-tap refresh.
const PWAUpdatePrompt = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  const close = () => setNeedRefresh(false)

  return (
    <AnimatePresence>
      {needRefresh && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.96 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          role="status"
          className="fixed z-[60] left-4 right-4 bottom-[calc(5rem+env(safe-area-inset-bottom))] md:left-auto md:right-6 md:bottom-6 md:max-w-sm"
        >
          <div className="m3-card m3-card-elevated flex items-center gap-3 p-4 shadow-[var(--elev-3)]">
            <span className="shape-well h-10 w-10 shrink-0">
              <RefreshCw className="w-4 h-4" />
            </span>
            <p className="flex-1 text-sm text-ink-2">
              A new version is available.
            </p>
            <button
              onClick={() => updateServiceWorker(true)}
              className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-on hover:brightness-110"
            >
              Refresh
            </button>
            <button
              onClick={close}
              aria-label="Dismiss"
              className="text-ink-3 hover:text-ink-2 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default PWAUpdatePrompt
